import React from "react";
import { Row, Col } from "antd";
import { DeleteFilled, CheckOutlined, CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { Modal, Button as StrapButton } from "reactstrap";



const ConfirmDelete = ({ isOpen, isLoading, title, subtitle, onClose, onConfirm }) => {


    return (
        <Modal
            centered
            fade={false}
            destroyOnClose
            isOpen={isOpen}
            modalClassName="p-2"
            style={{ minWidth: "15%" }}
            onClosed={onClose}
        >
            <Row gutter={24} className="p-4">
                <Col span={24}>
                    <Row gutter={24} className="mb-3">
                        <Col span={24} className="text-center" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className="text-center icon-container-delete" style={{ backgroundColor: "#fff1f0", border: "1px solid #ffccc7", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <DeleteFilled style={{ fontSize: "25px", fontWeight: "bold", color: "#ff6b72" }} />
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={24} className="mt-4">
                        <Col xl={3} lg={2} md={0} sm={0} xs={0} />
                        <Col xl={18} lg={20} md={24} sm={24} xs={24} className="text-center">
                            <h5 style={{ fontSize: "18px" }}>{title}</h5>
                            <p style={{ fontSize: "15px" }}>{subtitle}</p>
                        </Col>
                    </Row>
                    <Row gutter={24} className="mt-3">
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                            <StrapButton
                                color="danger"
                                onClick={onConfirm}
                                disabled={isLoading}
                                className="w-100 d-flex align-items-center justify-content-center"
                            >
                                {isLoading ? <LoadingOutlined className="mr-2" /> : <CheckOutlined className="mr-2" />}
                                Konfirmo
                            </StrapButton>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                            <StrapButton
                                outline
                                color="primary"
                                onClick={onClose}
                                className="w-100 d-flex align-items-center justify-content-center"
                            >
                                <CloseOutlined className="mr-2" />
                                Mbyll
                            </StrapButton>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Modal>
    );
};

export default ConfirmDelete;